import { defineComponent as _defineComponent } from 'vue'
import { fetchTaskHistoryList } from '@/apis/taskList'
import { translate } from '@/util/commonFun'
import Vue, { nextTick, onMounted, ref } from 'vue'

import mBatchList from './components/m-batch-list.vue'
import mHistoryList from './components/m-history-list.vue'
import mRefuseHistoryModal from './components/m-refuse-history-modal.vue'
import mTaskList from './components/m-task-list.vue'
import { dealHistoryDataFromApi, getTaskList } from './module/taskList'
import { BatchHistoryType } from './types/batchHistory'
import { TaskType } from './types/taskCard'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const tabs = ref([
  {
    label: 'taskPage.tab1',
    key: 'taskList',
  },
  {
    label: 'taskPage.tab2',
    key: 'batchList',
  },
  {
    label: 'taskPage.taskCard.save',
    key: 'recordList',
  },
])

const isLoadingTask = ref(false)
const taskList = ref<TaskType[]>([])
const batchList = ref<TaskType[]>([])
const total = ref(0)
const batchTotal = ref(0)
const historyTotal = ref(0)
const isShowRefuseHistory = ref(false)
const taskListRef = ref()
const historyListRef = ref()

const batchHistoryList = ref<BatchHistoryType[]>([])

// const batchList = computed(() => {
//   return taskList.value.filter((task) => task.isInBatchList)
// })

async function handlePageChange(
  currentPage: number,
  type?: 0 | 1 | 2 | 3 | 4,
  extoraInfo?: any
) {
  isLoadingTask.value = true
  const payload = {
    page: currentPage,
    limit: 12,
  }
  if (extoraInfo) Object.assign(payload, extoraInfo)
  if (type && type > 0) Object.assign(payload, { current_step: type })
  // 请求任务数据
  const { total: totalCount, taskList: taskData } = await getTaskList(payload)
  // 不同列表赋值不同数据
  if (type == 2) {
    batchList.value = taskData
    batchTotal.value = totalCount
  } else {
    taskList.value = taskData
    total.value = totalCount
  }
  isLoadingTask.value = false
}

function handleClickRefuseHistory() {
  isShowRefuseHistory.value = true
}

function handleCloseRefuseModel(visible: boolean) {
  isShowRefuseHistory.value = visible
}

function translateLang(key: string) {
  return translate(key)
}

async function handleHistoryPageChange(
  page: number,
  searchInfo?: { [key: string]: any }
) {
  isLoadingTask.value = true
  const payload = {
    limit: 10,
    page,
  }
  if (searchInfo) {
    Object.assign(payload, searchInfo)
  }

  const res = await fetchTaskHistoryList(payload)
  isLoadingTask.value = false
  if (res.status) {
    historyTotal.value = res.data.total
    batchHistoryList.value = dealHistoryDataFromApi(res.data.material_list)
  } else {
    Vue.prototype.$message({
      message: '请求失败，请稍后重试!',
      type: 'error',
      duration: 2000,
    })
  }
}

async function handleChangeTab(tab: string) {
  if (tab == 'taskList') {
    if (taskListRef.value) {
      taskListRef.value[0].refetchCurrentPage()
    }
  } else if (tab == 'recordList') {
    nextTick(() => {
      historyListRef.value[0].handleHistoryChangePage(1)
    })
  }
}

onMounted(async () => {
  // 不存type默认为0
  await handlePageChange(1)
  await handlePageChange(1, 2)
})

return { __sfc: true,tabs, isLoadingTask, taskList, batchList, total, batchTotal, historyTotal, isShowRefuseHistory, taskListRef, historyListRef, batchHistoryList, handlePageChange, handleClickRefuseHistory, handleCloseRefuseModel, translateLang, handleHistoryPageChange, handleChangeTab, mBatchList, mHistoryList, mRefuseHistoryModal, mTaskList }
}

})